module.exports = __webpack_public_path__ + "animations/review.json";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/animations/review.json
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--4-0!/tool/project/client/src/site__mhf/animations/review.json
// module chunks = site__mhf